(ns common.schema.entities.attestation-condition
  (:require
   [common.schema.schema-utils :as su]))

(def condition-status-options
  "Canonical enum for an attestation condition's status. Single source for the
   edit modal's select AND the read views (peek panel / details modal / PDF), so
   they can't drift on either the value set or the labels."
  [{:key   :attestation-condition.status/true
    :label "Met"}
   {:key   :attestation-condition.status/false
    :label "Not met"}])

(def schema
  (concat

   (su/text-simple-field :attestation-condition/title
                         "Title"
                         {:authorization su/access-user-user})

   (su/text-multiline-field :attestation-condition/description
                            "Description"
                            {:authorization su/access-user-user})

   (su/keyword-field :attestation-condition/status
                     "Condition status"
                     condition-status-options
                     {:authorization su/access-user-user})

   (su/date-field :attestation-condition/completed-on
                  "Completed on"
                  {:authorization su/access-user-user})

   (su/single-ref-field :attestation-condition/completed-by
                        "Completed by"
                        [:entity.type/account]
                        {:authorization su/access-user-user})))

(def required-fields
  #{:attestation-condition/title
    :attestation-condition/status})
